<template>
    <div class="footer text-sm-left text-center black white--text">
        <v-container fluid class="footer-items">
            <v-container grid-list-lg>
                <v-layout row wrap>
                    <v-flex xs12 sm3 class="text-center mobile-padding">
                        <img :src="require('../assets/logo.png')" />
                        <div class="icons">
                            <v-btn icon href="https://www.facebook.com/fruitisimo/" target="_blank">
                                <v-icon color="white">mdi-facebook</v-icon>
                            </v-btn>
                            <v-btn icon href="https://www.instagram.com/fruitisimo.cz/" target="_blank">
                                <v-icon color="white">mdi-instagram</v-icon>
                            </v-btn>
                            <v-btn icon href="https://www.youtube.com/channel/UCWXRVOwICMQjZNNmONK8gSQ" target="_blank">
                                <v-icon color="white">mdi-youtube</v-icon>
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm3 class="text-center white--text mobile-padding">
                        <a class="white--text no-decoration" target="_blank" href="https://www.google.cz/maps/place/%C4%8Ceskomoravsk%C3%A1+2420%2F15a,+190+00+Praha+9/@50.1039042,14.4886419,17z/data=!3m1!4b1!4m5!3m4!1s0x470becb4ad75e377:0x5ffbedfb6454607b!8m2!3d50.1039042!4d14.4908306">
                            <v-icon x-large color="white">mdi-map-marker</v-icon>
                            <div class="mt-2">
                                <p class="mb-0">Českomoravská 2420/15a,</p>
                                <p class="mb-0">190 00, Praha 9</p>
                            </div>
                        </a>
                    </v-flex>
                    <v-flex xs12 sm3 class="text-center white--text mobile-padding">
                        <a class="white--text no-decoration" href="mailto:info@riwal.de">
                            <v-icon x-large color="white">mdi-email</v-icon>
                            <div class="mt-2">
                                <p class="mb-0">info@riwal.de</p>
                            </div>
                        </a>
                    </v-flex>
                    <v-flex xs12 sm3 class="text-center white--text mobile-padding">
                        <a class="white--text no-decoration" href="tel:+420724341333">
                            <v-icon x-large color="white">mdi-phone</v-icon>
                            <div class="mt-2">
                                <p class="mb-0">+420 724 341 333</p>
                            </div>
                        </a>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-container>
        <v-container fluid class="footer-info primary">
            <v-container class="text-left">
                <p class="mb-0 white--text">© Fruitisimo Bistro Café</p>
            </v-container>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'Footer',
        data: () => {
            return {
                items: [
                    {
                        title: 'Adresa',
                        text: 'Za Hotely 814, 252 62, Horoměřice, Česká republika​'
                    },
                    {
                        title: 'Telefon',
                        text: '+420 777 444 545'
                    },
                    {
                        title: 'Email',
                        text: 'info@policecard.cz'
                    }
                ]
            }
        }
    }
</script>

<style lang="scss">
    .footer {
        .footer-items {
            padding: 50px 0 ;
        }
        @media #{$pixel-less-phone} {
           .mobile-padding {
               padding-top: 1rem !important;
               padding-bottom: 1rem !important;
           }
        }
        a.no-decoration {
            text-decoration: none;
        }
        img {
            max-width: 100%;
            height: auto;
        }
        h2 {
            font-size: 31px;
            margin-bottom: 20px;
            @media #{$pixel-less-phone} {
                padding-top: 30px;
            }
        }
        .divider {
            margin: auto;
            padding: 20px 0;
        }
        .footer-info {
            background-color: #f6f9f9;
            img {
                width: 45%;
            }
            h5 {
                font-size: 18px;
                margin-bottom: 20px;
            }
        }
    }
</style>